import { useEffect, useRef, useState } from "react";
import { api } from "./api";
import { t } from "./kieli";

/* ═══════════════════════════════════════════════════════════
   Pienoiskuva ja iso kuva samalla sivulla (Toni 17.10.2026 klo 07.40 kohta 2).

   Punchin kuva näkyi vain lukumääränä, ja linkki avasi sen uuteen
   välilehteen. Pienoiskuvan napautus avaa nyt kuvan isona saman
   sivun päälle (<dialog>), joten täytetty lomake ei katoa eikä
   näkymästä poistuta. Sulkeminen: ×, Esc tai napautus kuvan ohi.

   Huom: kuvan lataus kirjautuu liite_lataus-lokiin kuten linkistä
   avaaminen. Pienoiskuvat ladataan vasta, kun kuvalista avataan
   (loading="lazy"), ei listan piirtyessä.
   ═══════════════════════════════════════════════════════════ */

export function onKuva(mime: string | null | undefined): boolean {
  return !!mime && mime.startsWith("image/");
}

export function Pienoiskuva({ id, nimi }: { id: number; nimi: string }) {
  const [auki, setAuki] = useState(false);
  return (
    <>
      <button type="button" className="pienoiskuva" data-pienoiskuva={id} onClick={() => setAuki(true)}
              aria-label={t("liite.avaa_isona", { nimi })} title={nimi}>
        <img src={api.liiteOsoite(id)} alt={nimi} loading="lazy" />
      </button>
      {auki && <IsoKuva id={id} nimi={nimi} sulje={() => setAuki(false)} />}
    </>
  );
}

export function IsoKuva({ id, nimi, sulje }: { id: number; nimi: string; sulje: () => void }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => { const d = ref.current; if (d && !d.open) d.showModal(); }, []);
  const kiinni = () => { ref.current?.close(); sulje(); };
  return (
    <dialog ref={ref} className="ikkuna kuvaikkuna" data-iso-kuva={id}
            onCancel={(e) => { e.preventDefault(); kiinni(); }}
            onClick={(e) => { if (e.target === ref.current) kiinni(); }}>
      <div className="ikkuna__sisalto">
        <div className="ikkuna__yla">
          <strong className="kuvaikkuna__nimi">{nimi}</strong>
          <button type="button" className="ikkuna__sulje" onClick={kiinni} aria-label={t("hl.sulje")}>×</button>
        </div>
        <img className="kuvaikkuna__kuva" src={api.liiteOsoite(id)} alt={nimi} />
      </div>
    </dialog>
  );
}
